var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"anchor-image-container"},[_c('swiper',{attrs:{"items":_vm.getImages,"options":{
        slidesPerView: 1,
      }},scopedSlots:_vm._u([{key:"slide",fn:function({ item }){return [_c('img',{staticClass:"anchor-image",attrs:{"src":item,"alt":"anchor-image"}})]}}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }